/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ScorecardInputs */

const en_nav_scorecard = /** @type {(inputs: Nav_ScorecardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scorecard`)
};

/**
* | output |
* | --- |
* | "Scorecard" |
*
* @param {Nav_ScorecardInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_scorecard = /** @type {((inputs?: Nav_ScorecardInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ScorecardInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_scorecard(inputs)
});